import {defineMessages} from "react-intl";

export interface CronValidationResult {
  valid: boolean;
  warning?: string;
}

const MESSAGES = defineMessages({
  CRON_invalid: {
    id: "studio.UI.cron.cron-util.invalid-format",
    defaultMessage: `Cron string is not valid.`,
  },
  CRON_range: {
    id: "studio.UI.cron.cron-util.invalid-range",
    defaultMessage: `Invalid value {value} found at column {number}. Must be between {min} and {max}`
  },

});

export const CronUtil = {
  validateCronString: (cronString: string, intl): CronValidationResult => {
    const validMonths = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    const validDays = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];
    const validCronPattern = /^((((\d+,)+\d+|(\d+[\/\-#]\d+)|(\/\d+)|\d+L?|\*(\/\d+)?|L(-\d+)?|\?|[A-Z]{3}(-[A-Z]{3})?) ?){5,7})$/;

    //convert words to numbers
    cronString = cronString.toUpperCase();
    for (let i = 0; i < validMonths.length; i++) {
      cronString = cronString.replace(validMonths[i], (i + 1).toString());
    }
    for (let i = 0; i < validDays.length; i++) {
      cronString = cronString.replace(validDays[i], (i + 1).toString());
    }

    if (!validCronPattern.test(cronString)) {
      return {
        valid: false,
        warning: intl.formatMessage(MESSAGES.CRON_invalid),
      };
    }

    // check actual cron values
    const cols = cronString.split(" ");

    //            ss, mm, hh, DD, MM, DOW
    const minval = [0, 0, 0, 1, 1, 0];
    const maxval = [59, 59, 23, 31, 12, 7];

    for (let i = 0; i < cols.length; i++) {
      if (cols[i] === "*") {
        continue;
      }

      // special characters  (, - * ? / L W #)
      if (/[,\-*?\/LW#]+/.test(cols[i])) {
        const numbers = cols[i].match(/\d+/g);
        if (numbers) {
          for (const sNumber of numbers) {
            const num = parseInt(sNumber, 10);
            if (num < minval[i] || num > maxval[i]) {
              return {
                valid: false,
                warning: intl.formatMessage(MESSAGES.CRON_range,
                    {value: cols[i], number: i + 1, min: minval[i], max: maxval[i]}),
              };
            }
          }
        }
        continue;
      }

      const value = parseInt(cols[i], 10);
      if (typeof value === "undefined" || value > maxval[i] || value < minval[i]) {
        return {
          valid: false,
          warning: intl.formatMessage(MESSAGES.CRON_range, {value, number: i + 1, min: minval[i], max: maxval[i]}),
        };
      }
    }
    return {valid: true};
  }
};